import React from 'react'
import { observer } from 'mobx-react'
import { Modal, Table, Checkbox } from 'react-bootstrap'
import * as defaultConst from '../../../constants/default_constants'
import BoolField from 'bstrap-react-mobx-admin/field/bool'
import DateInput from '../../input/date'
import DateField from 'react-mobx-admin/components/common/field/date'
import OptionsField from 'react-mobx-admin/components/common/field/opts'
import SelectInput from '../../input/select'
import TextField from 'react-mobx-admin/components/common/field/text'

export default observer(({ store }) => {
  if (!store.rightsCopyModal || !store.cv) {
    return null
  }
  const contractId = store.cv.record && store.cv.record.get('contract_id')
  const state = store.cv.subentities.rightsCopy
  const updateFormField = store.updateSubentityField.bind(store, state, store.cv.items)
  const errors = state.errors
  const contractitem = state.record.get('contractitem')
  const foundData = state.record.get('rights') && state.record.get('rights').length > 0
  const controlTimestamp = Math.round(new Date().getTime())

  const changeCheckbox = id => {
    const selection = state.record && state.record.has('selection') && state.record.get('selection')

    if (selection) {
      const newSelection = [...selection]
      if (selection.includes(id)) {
        newSelection.splice(newSelection.indexOf(id), 1)
      } else {
        newSelection.push(id)
      }
      state.record.set('selection', newSelection)
      if (newSelection && newSelection.length > 1) {
        store._runSubentityGlobalValidator(state)
      } else {
        state.errors.delete('_global')
      }
    }
  }

  const fetchData = () => {
    if (state.record.get('selection') && state.record.get('selection').length > 0) {
      for (const idx of state.record.get('selection')) {
        const i = state.record.get('rights').find(c => c.id === idx)
        const newI = i
        delete newI.id
        newI.control_timestamp = controlTimestamp + idx
        newI.start_license_period = i.start_license_period
        newI.end_license_period = (state.record.has('end_license_period') &&
          state.record.get('end_license_period')) ||
          i.end_license_period
        store.cv.record.get('rights').push(newI)
      }
    }
    closeModal()
  }

  const closeModal = () => {
    state.record.set('contractitem', null)
    state.record.delete('contractitemFetched')
    state.record.set('rights', null)
    store.toggleRightsCopyModal()
  }

  const checkboxTable = () => {
    return state.record.get('rights').map(c => {
      const dateStart = c.start_license_period
      const isChecked = state.record.has('selection') && state.record.get('selection') && state.record.get('selection').includes(c.id)
      return (
        <tr key={c.id.toString()}>
          <td><Checkbox onClick={() => changeCheckbox(c.id)} checked={isChecked} /></td>
          <td><TextField val={c.id} /></td>
          <td><DateField val={dateStart} /></td>
          <td><DateField val={c.end_license_period} /></td>
          <td><TextField val={c.regions} /></td>
          <td><TextField val={c.canceled_date} /></td>
          <td><OptionsField val={c.status} options={store.options.get('ContractItemStatus')} labelattr='text' valueattr='value' /></td>
          <td><OptionsField val={c.platform} options={store.options.get('Platforms')} labelattr='text' valueattr='value' /></td>
          <td><TextField val={c.right_type} /></td>
          <td><BoolField val={c.rights_exclusive_flg} /></td>
          <td><OptionsField val={c.pricing_tier} options={store.options.get('ContractPricingTier')} labelattr='text' valueattr='value' /></td>
          <td><TextField val={c.minimum_fee_sd} /></td>
          <td><TextField val={c.minimum_fee_hd} /></td>
        </tr>
      )
    })
  }

  return (
    <Modal show backdrop='static' onHide={closeModal}>
      <Modal.Header closeButton>
        <Modal.Title>
          {store.__('Copy rights from another title')}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <SelectInput
          attr={'contractitem'}
          errors={errors}
          label={store.__('Titles')}
          labelattr='title'
          onChange={updateFormField}
          optionsattr={'contractitems'}
          optionsrecord={store.options}
          record={state.record}
          valueFilterFc={i => (parseInt(i.contract_id) !== parseInt(contractId))}
          valueattr='id'
        />

        {foundData &&
          <Table striped bordered condensed>
            <thead>
              <tr>
                <th />
                <th>{store.__('ID')}</th>
                <th>{store.__('license starts')}</th>
                <th>{store.__('license ends')}</th>
                <th>{store.__('regions')}</th>
                <th>{store.__('canceled date')}</th>
                <th>{store.__('status')}</th>
                <th>{store.__('platform')}</th>
                <th>{store.__('right type')}</th>
                <th>{store.__('rights excl.')}</th>
                <th>{store.__('pricing tier')}</th>
                <th>{store.__('minimum fee SD')}</th>
                <th>{store.__('minimum fee HD')}</th>
              </tr>
            </thead>
            <tbody>
              {checkboxTable()}
            </tbody>
          </Table>}

        {foundData ? (<React.Fragment>
          <DateInput
            label={store.__('License starts (override)')}
            attr={'start_license_period'}
            record={state.record}
            onChange={updateFormField}
            errors={errors} />

          <DateInput
            label={store.__('License ends (override)')}
            attr={'end_license_period'}
            record={state.record}
            onChange={updateFormField}
            errors={errors} />
        </React.Fragment>) : null
        }

        {contractitem && state.record.has('contractitemFetched') && !foundData && (
          <div className='alert alert-warning fade in'>
            {store.__('No relevant data were found in selected item')}
          </div>
        )}

        {errors.has('_global') && (
          <div className='alert alert-danger fade in'>
            <strong>Error! </strong>
            {errors.get('_global')}
          </div>
        )}

      </Modal.Body>
      <Modal.Footer>
        <div className='btn-group' role='group'>
          <button
            disabled={errors.size > 0 || !state.record.get('rights') || !foundData}
            type='button' className='btn btn-primary'
            onClick={fetchData}>
            {store.__('Submit')}
          </button>
          <button type='button' className='btn btn-default'
            onClick={closeModal}>
            {store.__(defaultConst.TITLE_CANCEL)}
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  )
})
